
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.188 8.752a9.686 9.686 0 00-7.792-6.405 10.12 10.12 0 00-2.792 0 9.682 9.682 0 00-7.789 6.397A9.533 9.533 0 002.25 12c0 1.124.19 2.22.562 3.248A9.686 9.686 0 0012 21.75c.471 0 .94-.033 1.396-.098a9.682 9.682 0 007.789-6.397A9.533 9.533 0 0021.75 12c0-1.124-.19-2.218-.562-3.247zm-1.844-.5h-3.043a16.287 16.287 0 00-1.443-3.979 8.166 8.166 0 014.486 3.978zM20.25 12c0 .771-.111 1.524-.321 2.251h-3.353c.103-.746.174-1.497.174-2.25 0-.756-.07-1.507-.173-2.25h3.353a8.09 8.09 0 01.32 2.25zM8.938 14.251a14.873 14.873 0 01-.188-2.25c0-.754.074-1.505.188-2.25h6.125c.113.743.187 1.494.187 2.25 0 .753-.074 1.505-.188 2.25H8.938zm-4.867 0a8.11 8.11 0 01-.321-2.25c0-.77.111-1.523.321-2.25h3.353a16.413 16.413 0 00-.174 2.25c0 .754.071 1.506.174 2.25H4.071zM12.849 3.81a14.805 14.805 0 011.912 4.443H9.238a14.805 14.805 0 011.913-4.442c.28-.028.559-.059.849-.059.29 0 .569.03.849.058zm-3.708.465a16.248 16.248 0 00-1.443 3.978H4.656a8.158 8.158 0 014.485-3.978zM4.657 15.751h3.042a16.304 16.304 0 001.442 3.975 8.164 8.164 0 01-4.484-3.975zm6.494 4.44a14.83 14.83 0 01-1.912-4.439h5.522a14.835 14.835 0 01-1.911 4.44 8.612 8.612 0 01-1.699 0zm3.708-.465a16.251 16.251 0 001.442-3.975h3.042a8.161 8.161 0 01-4.484 3.975z","fill":"currentColor"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/icons/globe.svg